import { Save } from '@mui/icons-material';
import { ButtonGroup, IconButton, styled } from '@mui/material';

import { Button } from 'components/mui/common/Button';

export const StyledResetButton = styled(Button)(({ theme }) => ({
  color: theme.palette.primary.dark,
  borderColor: theme.palette.secondary.dark,
  maxWidth: '40%',
}));

export const StyledButton = styled(Button)(() => ({
  borderColor: 'white !important',
}));

export const FilterActionsWrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  marginLeft: theme.spacing(1),
  '& .MuiIconButton-root': {
    padding: theme.spacing(0.5),
    backgroundColor: theme.palette.background.paper,
    border: `1px solid ${theme.palette.divider}`,
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    },
  },
}));

export const StyledIconButton = styled(IconButton)(() => ({
  border: 'none !important',
}));

export const SavedFiltersWrapper = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
}));

export const SavedWrapper = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  marginTop: '16px',
  gap: '16px',
}));

export const StyledSaveIcon = styled(Save)(() => ({
  color: 'white',
}));

export const StyledButtonGroup = styled(ButtonGroup)({
  '& .MuiButton-root': {
    borderColor: 'white !important',
  },
});

export const StyledSaveButton = styled(Button)(() => ({
  maxWidth: '30%',
}));

export const FooterWrapper = styled('div')(() => ({
  display: 'flex',
  gap: '16px',
  background: 'white',
  width: '100%',
  paddingTop: '10px',
  paddingBottom: '10px',
}));
